<template>
  <div
    class="word-chain-wrapper"
    :class="{'store-delivery': storeDelivery}"
    @click="openUrl"
  >
    <p class="text">
      <span class="content">{{text}}</span>
      <el-popover
        v-if="!storeDelivery"
        placement="bottom"
        trigger="hover"
        popper-class="word-chain-popper-class"
      >
        <p>{{tipTxt}}</p>
        <i class="icon-outlined_information text-icon" slot="reference"></i>
      </el-popover>
    </p>
  </div>
</template>
<script>
import { replaceUrl } from '@/utils/methods'
export default {
  name: 'WordChain',
  props: {
    text: String,
    url: String,
    orderId: String,
    orderStatus: Number,
    storeDelivery: Boolean
  },
  data() {
    return {
      tipTxt: this.$t('超时赔付规则说明')
    }
  },
  methods: {
    openUrl() {
      if (!this.url) return
      this.$trackEvent({
        eventId: 'sailing_c_x_order_tips_ck',
        eventLabel: '订单配送规则点击',
        attrs: {
          order_id: this.orderId,
          order_status: this.orderStatus,
        }
      })
      window.open(replaceUrl(this.url, 'locale'), '_blank')
    }
  }
}
</script>
<style lang="scss">
.word-chain-popper-class {
  padding: 10px 12px;
  border: none !important;
  .popper__arrow {
    border: none;
  }
}
</style>
<style lang="scss" scoped>
.word-chain-wrapper {
  padding: 12px 80px 12px 10px;
  border-radius: 4px;
  background: #F3FAF7 url('./img/timeout.png') no-repeat right center;
  background-size: 64px 54px;
  cursor: pointer;
}
.store-delivery {
  background: #F3FAF7;
}
.text {
  line-height: 18px;
  font-family: 'Aspira Medium';
  font-weight: 500;
  font-size: 0;
  color: #1BB17C;
  font-weight: 500;
}
.text .content {
  font-size: 14px;
  vertical-align: middle;
}
.text .text-icon {
  padding: 2px 0;
  height: 18px;
  font-size: 14px;
  vertical-align: middle;
}

@media screen and (max-width: 768px) {
  .word-chain-wrapper {
    padding: rem(24) rem(128) rem(24) rem(24);
    border-radius: rem(8);
    background-size: 64px 54px;
  }
  .text {
    font-size: rem(28);
    line-height: rem(36);
  }
}
</style>